import {
  Button,
  NavBar,
  Icon,
  Toast,
  Tabs,
  WhiteSpace,
  SearchBar,
  DatePicker,
} from "antd-mobile";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import { LeftOutline, RightOutline } from "antd-mobile-icons";
import instance from "../../../util/axios";
import moment from "moment";
import { util } from "prettier";
const KaoqinList = styled.div`
  .line {
    width: 100%;
    height: 1px;
    background-color: #999393;
  }
  .kaoqinFrom {
    padding: 0 15px 0 15px;
    margin-top: 10px;
  }
  .kaoqinFrom p {
    display: flex;
    justify-content: space-between;
  }
  .d {
    width: 100%;
    text-align: center;
    padding: 10px 0 10px 0;
  }
  .s {
    padding: 5p;
    border: 1px solid gray;
    border-radius: 5px;
  }
`;
interface attendancelArray {
  应出勤: string;
  年假: string;
  事假: string;
  病假: string;
  产假: string;
  探亲假: string;
  公假: string;
  婚假: string;
  剩余年假天数: string;
  剩余换休天数: string;
  加班: string;
  在岗: string;
  换休: string;
  停职轮训: string;
  丧假: string;
}
export default function Attendance() {
  const GridStyle: React.CSSProperties = {
    padding: "5px 0",
  };
  const [tankuang, setTankuang] = useState<{
    visible: boolean;
    rejectId?: string;
    userId?: string;
  }>({
    visible: false,
  });
  const history = useHistory();
  const [attendancelList, setAttendancelList] = useState<attendancelArray[]>(
    []
  );
  const year = moment().year();
  const month = moment().month();
  const [dateValue, setDateValue] = useState<Date>();

  useEffect(() => {
    console.log(dateValue);
    let selectTime = moment(dateValue).format("YYYY-MM-DD HH:mm:ss");
    // console.log(selectTime)
    let selectYear = selectTime.substring(0, 4);
    if (dateValue == undefined) {
      let selectMonth = parseInt(selectTime.substring(5, 7)) - 1;
      instance
        .post(
          `/oa/attendanceManage/attendance/getMyAttendance?year=${selectYear}&month=${selectMonth}`
        )
        .then((resp) => {
          // console.log(resp)
          // console.log(resp.data.Data)
          if (resp.data.Status === "1") {
            setAttendancelList(resp.data.Data);
          }
        });
    } else {
      let selectMonth = parseInt(selectTime.substring(5, 7));
      instance
        .post(
          `/oa/attendanceManage/attendance/getMyAttendance?year=${selectYear}&month=${selectMonth}`
        )
        .then((resp) => {
          // console.log(resp)
          console.log(resp.data.Data);
          if (resp.data.Status === "1") {
            setAttendancelList(resp.data.Data);
          }
        });
    }
    // console.log(selectYear)
    // console.log(selectMonth)
  }, [dateValue]);
  return (
    <>
      <KaoqinList>
        <div className="body">
          <NavBar
            className="orderNavBar"
            icon={
              <Icon
                type="left"
                onClick={() => {
                  history.push(`/hr/myquery`);
                  // history.go(-1);
                }}
              />
            }
          >
            月度明细
          </NavBar>
          <WhiteSpace />
          {/* <p style={{ textAlign: "center" }}>
                        <LeftOutline style={{ fontSize: 17, fontWeight: 600, marginRight: 5 }} />
                        <span style={{ fontSize: 17, }}>2021年11月</span>
                        <RightOutline style={{ fontSize: 17, fontWeight: 600, marginLeft: 5 }} />
                    </p> */}
          <div className="d">
            <DatePicker
              mode="month"
              title="请选择月份"
              extra="Optional"
              value={dateValue}
              maxDate={new Date(year, month - 1)}
              onChange={(date) => {
                console.log(date);
                setDateValue(date);
              }}
            >
              {/* <span style={{ padding: 5, border: '1px solid gray', borderRadius: 5 }}>{(moment(dateValue).format("YYYY-MM-DD HH:mm:ss")).substring(0, 4)}年 {parseInt((moment(dateValue).format("YYYY-MM-DD HH:mm:ss")).substring(5, 7))}月</span> */}

              {dateValue == undefined ? (
                <span className="s">
                  {moment(dateValue)
                    .format("YYYY-MM-DD HH:mm:ss")
                    .substring(0, 4)}
                  年{" "}
                  {parseInt(
                    moment(dateValue)
                      .format("YYYY-MM-DD HH:mm:ss")
                      .substring(5, 7)
                  ) - 1}
                  月
                </span>
              ) : (
                <span className="s">
                  {moment(dateValue)
                    .format("YYYY-MM-DD HH:mm:ss")
                    .substring(0, 4)}
                  年{" "}
                  {parseInt(
                    moment(dateValue)
                      .format("YYYY-MM-DD HH:mm:ss")
                      .substring(5, 7)
                  )}
                  月
                </span>
              )}
            </DatePicker>
          </div>
          <div className="line"></div>
          {attendancelList.map((item) => (
            <div className="kaoqinFrom">
              <p>
                <span>应出勤天数：</span>
                <span>{item.应出勤}天</span>
              </p>
              <p>
                <span>出勤天数：</span>
                <span>{item.在岗}天</span>
              </p>
              <p>
                <span>换休天数：</span>
                <span>{item.换休}天</span>
              </p>
              <p>
                <span>停职轮训天数：</span>
                <span>{item.停职轮训}天</span>
              </p>
              <p>
                <span>婚假天数：</span>
                <span>{item.婚假}天</span>
              </p>
              <p>
                <span>丧假天数：</span>
                <span>{item.丧假}天</span>
              </p>
              <p>
                <span>公假天数：</span>
                <span>{item.公假}天</span>
              </p>
              <p>
                <span>产假天数：</span>
                <span>{item.产假}天</span>
              </p>
              <p>
                <span>年假天数：</span>
                <span>{item.年假}天</span>
              </p>
              <p>
                <span>探亲假天数：</span>
                <span>{item.探亲假}天</span>
              </p>
              <p>
                <span>病假天数：</span>
                <span>{item.病假}天</span>
              </p>
              <p>
                <span>事假天数：</span>
                <span>{item.事假}天</span>
              </p>
              <p>
                <span>加班：</span>
                <span>{item.加班}天</span>
              </p>
              <p>
                <span>剩余年假天数：</span>
                <span>{item.剩余年假天数}天</span>
              </p>
              <p>
                <span>剩余换休天数：</span>
                <span>{item.剩余换休天数}天</span>
              </p>
            </div>
          ))}
          {attendancelList.length === 0 && (
            <div style={{ textAlign: "center", marginTop: 10 }}>
              <span>暂无数据</span>
            </div>
          )}
        </div>
      </KaoqinList>
    </>
  );
}
